import { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery,
  Avatar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { fetchDocuments } from "../utils/FetchDocuments";
import { useFirebaseAuth } from "../hooks/useFirebaseAuth";
import BlueLogo from "../assets/logos/gaadikharcha-logo-blue.png";
import { usePlanStatus } from "../hooks/usePlanStatus";

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [companyName, setCompanyName] = useState<string>("");
  const [companyLogo, setCompanyLogo] = useState<string>("");
  const { user, loading } = useFirebaseAuth();
  const { planStatus } = usePlanStatus();
  useEffect(() => {
    if (user && planStatus && !loading) {
      fetchCompanyLogo();
      setCompanyName(planStatus?.company?.name || "");
    }
  }, [user, loading, planStatus]);

  const fetchCompanyLogo = async () => {
    try {
      if (planStatus?.company?.id) {
        const logo = await fetchDocuments({
          documentType: "company-profile",
          documentTypeId: planStatus?.company?.id || "",
          documentContext: "company",
        });
        if (logo && logo?.length > 0) {
          setCompanyLogo(logo[0]?.presignedUrl);
        }
      }
    } catch (error) {
      return null;
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "white",
        color: "text.primary",
        boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
      }}
    >
      <Toolbar sx={{ minHeight: "64px !important" }}>
        {isMobile && (
          <IconButton
            onClick={onMenuClick}
            edge="start"
            sx={{
              mr: isMobile ? 0 : 2,
              color: theme.palette.primary.main,
            }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isMobile ? "center" : "flex-start",
            }}
          >
            <img
              src={BlueLogo}
              alt="GaadiKharcha"
              style={{
                width: isMobile ? "80px" : "100px",
                height: "auto",
                marginLeft: isMobile ? "0px" : "10px",
              }}
            />
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          {companyLogo && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isMobile ? "center" : "flex-start",
                }}
              >
                <img
                  src={companyLogo}
                  style={{
                    height: "40px",
                    width: "auto",
                    marginRight: "10px",
                  }}
                />
              </Box>
            </Box>
          )}

          {/* ifMobile then only show logo */}
          {!isMobile && !companyLogo && (
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                color: theme.palette.text.secondary,
              }}
            >
              {companyName}
            </Typography>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
